import React from 'react'
import VehicleClass from '../models/VehicleClass.js';
//import RezCentral from '../components/RezCentral.js';
import {Container, Row, Col, Button, Spinner} from 'react-bootstrap/';

export default class Upgrade extends React.Component {
  currentVehicleClass = {};

  constructor(props){
    super(props);

    this.state = {
      loading : false,
      vehicleClass : new VehicleClass()
    }

    // copy value to prevent current image switching when upgrade happens
    if(typeof this.props.currentClass !== 'undefined')
    this.currentVehicleClass = this.props.currentClass;

    this.handleUpgradeClick = this.handleUpgradeClick.bind(this);
  }

  handleUpgradeClick(e){
    e.preventDefault();
    var self = this;
    var arr = e.target.value.split('|');
    this.setState({ loading : true });

    var vehicleClass = new VehicleClass();
    var rateId = arr[1];
    var vehClass = arr[0];
    var modelDesc = arr[2];
    var totalCharges = parseFloat(arr[3]);

    vehicleClass.setClass(vehClass);
    vehicleClass.setRateId(rateId);
    vehicleClass.setModelDesc(modelDesc);
    vehicleClass.setTotalCharges(totalCharges)
    vehicleClass.setIsUpgrade(true);

    this.props.setUpgradeClass(vehicleClass);

    // update vehicle class in state them update bill data
    setTimeout(function(){
      self.setState(
        { vehicleClass : vehicleClass, loading : false },
        () => {
          self.props.getBill();
        }
      );
    }, 1000);
  }

  render() {
    let UpgradeOptions = [];

    if(this.props.upgradeList.length > 0){
      var upgrade = this.props.upgradeList[0];

      if(this.state.vehicleClass.isUpgrade){ // upgraded
        UpgradeOptions =
        <Container fluid className="upgrade-success">
          <Row xs={1} md={2} className="mb-3 align-items-center">
            <Col className="p-0 text-center">
                <img src={'reservation/carimages/' + this.state.vehicleClass.classCode.toLowerCase() + '.jpg'} alt="" />
            </Col>
            <Col className="upgrade-desc text-center">
                <span className="h3">Vehicle upgraded <i className="bi bi-check-lg text-success"></i></span>
            </Col>
          </Row>
        </Container>
      }else if(this.props.currentClass){ // if current class sent as prop this display current and upgrade
        UpgradeOptions =
        <Container fluid className="upgrade-vehicle">
          <Row className="mb-0 pb-0 d-xs-block d-md-none">
            <Col className="upgrade-desc text-center">
              <h5>Would you like to upgrade?</h5><br/>
              <b>{upgrade.modelDesc}</b><br/>
              {upgrade.classDesc}<br/>
              <p>Upgrade for only <b>${(parseFloat(upgrade.total) - parseFloat(this.props.totalCharges)).toFixed(2)}</b> more. ($ <b>{upgrade.total}</b> total)</p><br/>
            </Col>
          </Row>
          <Row xs={1} md={2} className="mb-3">
            <Col className="p-0">
                <Container fluid className="m-1">
                  <Row className="p-0">
                    <Col className="p-0 text-center">
                      <img src={'reservation/carimages/' + this.currentVehicleClass.classCode.toLowerCase() + '.jpg'} alt="" />
                      <b>{this.currentVehicleClass.classDesc}</b><br/>
                      (Current Selection)
                    </Col>
                    <Col className="p-0 arrow-column text-center"><i className="bi bi-arrow-right"></i></Col>
                    <Col className="p-0 text-center">
                      <img src={'reservation/' + upgrade.img} alt="" /><br/>
                      <b>{upgrade.modelDesc}</b><br/>
                      {/*upgrade.classDesc*/}
                    </Col>
                  </Row>
                </Container>
            </Col>
            <Col className="upgrade-desc text-center d-none d-md-block">
              <h5>Would you like to upgrade?</h5><br/>
              <b>{upgrade.modelDesc}</b><br/>
              {upgrade.classDesc}<br/>
              <p>Upgrade for only <b>${(parseFloat(upgrade.total) - parseFloat(this.props.totalCharges)).toFixed(2)}</b> more. ($ <b>{upgrade.total}</b> total)</p><br/>
                <Button value={upgrade.classCode + '|' + upgrade.rateId + '|' + upgrade.modelDesc + '|' + upgrade.total} onClick={this.handleUpgradeClick}>
                  {this.state.loading ?
                    <Spinner animation="border" role="status"></Spinner>  : "Upgrade"
                  }
                </Button>
            </Col>
          </Row>
          <Row className="d-xs-block d-md-none">
            <Col className="upgrade-desc text-center">
              <Button value={upgrade.classCode + '|' + upgrade.rateId + '|' + upgrade.modelDesc + '|' + upgrade.total} onClick={this.handleUpgradeClick}>
                {this.state.loading ?
                  <Spinner animation="border" role="status"></Spinner>  : "Upgrade"
                }
              </Button>
            </Col>
          </Row>
        </Container>
      }else{ // review page, no current class available
        UpgradeOptions =
        <Container fluid className="p-0">
        <Row className="mt-3">
          <Col>
            <h5>Would you like to upgrade?</h5><br/>
          </Col>
        </Row>
        <Row xs={1} sm={2} className="upgrade-vehicle mt-3">
          <Col className="upgrade-img">
            <img className="img-fluid" src={'reservation/' + upgrade.img} alt="" />
          </Col>
          <Col className="upgrade-desc">
            <b>{upgrade.modelDesc}</b><br/>
            {upgrade.classDesc}<br/>
            <p>Upgrade for only <b>${(parseFloat(upgrade.total) - parseFloat(this.props.totalCharges)).toFixed(2)}</b> more. ($ <b>{upgrade.total}</b> total)</p><br/>
            <Button value={upgrade.classCode + '|' + upgrade.rateId + '|' + upgrade.modelDesc + '|' + upgrade.total} onClick={this.handleUpgradeClick}>
              {this.state.loading ?
                <Spinner animation="border" role="status"></Spinner>  : "Upgrade"
              }
            </Button>
          </Col>
        </Row>
      </Container>
    }
  }

    return (<>{UpgradeOptions}</>);
  }
}
